export const ADMIN = "SYSDBA";
export const MANAGER = "КМН";
